import { ApiService } from "../../services/api.service";
import { adminPermissionsType, payinTransactionsType } from "../../types";
import Cookies from "universal-cookie";
import { useEffect, useState, ChangeEvent, useRef, FormEvent } from "react";
import { Typography, Pagination, Divider, Tooltip, IconButton } from "@mui/material";
import PageLoading from "../PageLoading/PageLoading";
import { Link } from "react-router-dom";
import { useOutletContext } from "../../OutletContext";
import { styled } from "@mui/system";
import Swal from "sweetalert2";
import { io } from 'socket.io-client';

import dayjs, { Dayjs } from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

const CustomPagination = styled(Pagination)({
    '& .MuiPaginationItem-root': {
        color: localStorage.getItem('theme') === 'light' ? 'black' : "rgba(255, 255, 255, .7)", // สีของหน้าที่ไม่ได้เลือก
    },
    '& .Mui-selected': {
        color: localStorage.getItem('theme') === 'light' ? 'black' : "white",
    },
});

const formatDate = (date: Dayjs | null) => {
    if (!date) return '';
    return date.format('YYYY-MM-DD');
};

const socket = io('https://api.bullpay.me');
const PayinTransactions = () => {
    const cookies = new Cookies(null, {path: '/'});
    const [countTransactions, setCountTransactions] = useState<number | null>(null);
    const [transactions, setTransactions] = useState<payinTransactionsType[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [page, setPage] = useState<number>(1);
    const [limit, setLimit] = useState<number>(10);
    const searchRef = useRef<HTMLInputElement>(null);
    const [searching, setSearching] = useState<boolean>(false);
    const [valueStartDate, setValueStartDate] = useState<Dayjs | null>(dayjs());
    const [valueEndDate, setValueEndDate] = useState<Dayjs | null>(dayjs());

    const context = useOutletContext();
    const [permissions, setPermissions] = useState<adminPermissionsType>({member: false, deposit_scb: false, promotion: false, create_admin: false, withdraw_transactions: false, report_all: false, report_all_data: false, report_click: false, settings: false, deposit_transactions: false, managelotto: false, manange_bank_account: false});
    useEffect(() => {
        const tmp_permissions: adminPermissionsType | null = context;
        if(tmp_permissions)
        {
            setPermissions(tmp_permissions);
        }
    }, []);

    useEffect(() => {
        getAllTransactions();
    }, [page, limit]);

    useEffect(() => {
        socket.emit('joinRoom', 'admin');

        socket.on('message', (msg) => {
            if(msg.type === 'updatepayin')
            {
                updateTransactions(msg.payinData);
            }
        });

        return () => {
            socket.off('message');
        };
    }, []);

    const updateTransactions = async (transaction: payinTransactionsType) => {
        setTransactions((prevTransactions) => {
            let tmp_prevTransaction = [...prevTransactions];
            const findIndexPrevTransaction = tmp_prevTransaction.findIndex(
                (element: payinTransactionsType) => element.ref_code === transaction.ref_code && element.customer_ref_code === transaction.customer_ref_code
            );
    
            if (findIndexPrevTransaction !== -1)
            {
                tmp_prevTransaction[findIndexPrevTransaction] = transaction;
                return tmp_prevTransaction;
            }
            else
            {
                return prevTransactions;
            }
        });
    };

    const getAllTransactions = async () => {
        if(loading)
        {
            return;
        }

        if(searching)
        {
            return searchTransactions();
        }

        setLoading(true);
        try {
            const service = new ApiService();
            const getTransactions = await service.getPayinTransactions(cookies.get('access_token'), formatDate(valueStartDate), formatDate(valueEndDate), page, limit);
            if(getTransactions.data.status_code !== 200)
            {
                return;
            }
            setCountTransactions(getTransactions.data.all_transactions_count);
            setTransactions(getTransactions.data.transactions);
        } catch (err) {
            console.log(err);
        }
        setLoading(false);
    }

    const handleChangePage = (_e: React.ChangeEvent<unknown>, value: number) => {
        setPage(value);
    };

    const submitSsearchTransactions = async (e: FormEvent) => {
        e.preventDefault();
        searchTransactions();
    }

    const searchTransactions = async () => {
        if(loading || !searchRef || !searchRef.current || searchRef.current.value.trim() === '')
        {
            return;
        }

        setLoading(true);
        try {
            const service = new ApiService();
            const getTransactions = await service.getPayinTransactionsSearch(cookies.get('access_token'), searchRef.current.value.trim());
            if(getTransactions.data.status_code !== 200)
            {
                return;
            }

            setCountTransactions(getTransactions.data.all_transactions_count);
            setTransactions(getTransactions.data.transactions);
            setSearching(true);
        } catch (err) {
            console.log(err);
        }
        setLoading(false);
    }

    return (
        <>
            {
                <PageLoading loading={loading} />
            }
            <>
                <div className="col-12 mb-3">
                    <div className="card p-2">
                        <div className="row">
                            <div className="col mb-2">
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        label=""
                                        value={valueStartDate}
                                        onChange={(newValue) => setValueStartDate(newValue)}
                                        sx={
                                            {
                                                backgroundColor: 'white',
                                                width: '100%',
                                                '& .MuiInputBase-root': {
                                                    height: '40px', // ความสูงของ Input Base
                                                    fontSize: 14,
                                                },
                                                '& .MuiPickersPopper-container': {
                                                    maxHeight: '40px', // ความสูงสูงสุดของ Popper
                                                },
                                            }
                                        }
                                        slotProps={{
                                            field: { clearable: true },
                                            popper: {
                                                disablePortal: true,
                                            },
                                        }}
                                        format="DD/MM/YYYY"
                                        defaultValue={dayjs()}
                                        maxDate={dayjs()}
                                    />
                                </LocalizationProvider>
                            </div>
                            <div className="col mb-2">
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        label=""
                                        value={valueEndDate}
                                        onChange={(newValue) => setValueEndDate(newValue)}
                                        sx={
                                            {
                                                backgroundColor: 'white',
                                                width: '100%',
                                                '& .MuiInputBase-root': {
                                                    height: '40px', // ความสูงของ Input Base
                                                    fontSize: 14,
                                                },
                                                '& .MuiPickersPopper-container': {
                                                    maxHeight: '40px', // ความสูงสูงสุดของ Popper
                                                },
                                            }
                                        }
                                        slotProps={{
                                            field: { clearable: true },
                                            popper: {
                                                disablePortal: true,
                                            },
                                        }}
                                        format="DD/MM/YYYY"
                                        defaultValue={dayjs()}
                                        minDate={valueStartDate || dayjs()}
                                        maxDate={dayjs()}
                                    />
                                </LocalizationProvider>
                            </div>
                            <div className="col-sm-12 col-md-2">
                                <button className="btn btn-primary w-100" onClick={getAllTransactions} disabled={loading}>SEARCH</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-12 mb-3">
                    <div className="card p-2">
                        <div className="row">
                            <div className="col-sm-12 col-xl-4">
                                <form id="formSearchTransactions" className="mb-3" onSubmit={submitSsearchTransactions}>
                                    <div className="row">
                                        <div className="col-sm-12 col-xl-6 mt-3">
                                            <input type="text" className="form-control" id="search_input_ref_code" name="search_input_ref_code"
                                                placeholder="Search..." ref={searchRef} />
                                        </div>
                                        <div className="col-sm-12 col-xl-4 mt-3">
                                            <button className="btn btn-primary d-grid w-100" type="submit">SEARCH</button>
                                        </div>
                                        <div className="col-sm-12 col-xl-2 mt-3">
                                            <button className="btn btn-danger d-grid w-100" type="button" onClick={() => {
                                                const element = document.getElementById('search_input_ref_code') as HTMLInputElement;
                                                if(element)
                                                {
                                                    element.value = '';
                                                    setSearching(false);
                                                    getAllTransactions();
                                                }
                                            }}>
                                                <i className="bx bx-x"></i>
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div className="col-sm-12 col-xl-8" style={{ 
                                display: `flex`,
                                justifyContent: `flex-end`,
                                alignContent: `center`,
                                alignItems: `center`
                            }}>
                                SHOW:&nbsp;
                                <select id="select2Basic" className="select2 form-select" data-allow-clear="true"
                                    style={{
                                        maxHeight: 40,
                                        maxWidth: 100
                                    }}
                                    defaultValue={`10`}
                                    onChange={(e: ChangeEvent<HTMLSelectElement>) => {
                                        if(!e.target)
                                        {
                                            return;
                                        }

                                        setLimit(parseInt(e.target.value));
                                    }}
                                >
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                    <option value="30">30</option>
                                    <option value="40">40</option>
                                    <option value="50">50</option>
                                    <option value="60">60</option>
                                    <option value="70">70</option>
                                    <option value="80">80</option>
                                    <option value="90">90</option>
                                    <option value="100">100</option>
                                    <option value="200">200</option>
                                    <option value="300">300</option>
                                    <option value="400">400</option>
                                    <option value="500">500</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-12 mb-3">
                    <div className="card p-2">
                        <div className="row g-2">
                            <div className="col-sm-12 col-xl-6" style={{
                                display: 'flex',
                                alignContent: `center`,
                                alignItems: `center`
                            }}>
                                <CustomPagination
                                    count={Math.ceil((countTransactions === null ? 0 : countTransactions) / limit)}
                                    color="primary"
                                    sx={{ color: 'white'}}
                                    onChange={handleChangePage}
                                    page={page}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card">
                    <div className="table-responsive">
                        <table className="table">
                            <thead className="border-top">
                                <tr>
                                    <th align="center">
                                        <Typography align="center" fontSize={`0.75rem`} fontWeight={`bold`}>
                                            REF CODE
                                        </Typography>
                                    </th>
                                    <th align="center" colSpan={2}>
                                        <Typography align="center" fontSize={`0.75rem`} fontWeight={`bold`}>
                                            AMOUNT
                                        </Typography>
                                    </th>
                                    <th align="center" colSpan={2}>
                                        <Typography align="center" fontSize={`0.75rem`} fontWeight={`bold`}>
                                            BALANCE
                                        </Typography>
                                    </th>
                                    <th align="center">
                                        <Typography align="center" fontSize={`0.75rem`} fontWeight={`bold`}>
                                            STATUS
                                        </Typography>
                                    </th>
                                    <th align="center">
                                        <Typography align="center" fontSize={`0.75rem`} fontWeight={`bold`}>
                                            UPDATED TIME
                                        </Typography>
                                    </th>
                                    <th align="center">
                                        <Typography align="center" fontSize={`0.75rem`} fontWeight={`bold`}>
                                            CREATED TIME
                                        </Typography>
                                    </th>
                                </tr>
                                <tr>
                                    <th colSpan={1}></th>
                                    <th align="center">
                                        <Typography align="center" fontSize={`0.75rem`} fontWeight={`bold`}>
                                            FULL
                                        </Typography>
                                    </th>
                                    <th align="center">
                                        <Typography align="center" fontSize={`0.75rem`} fontWeight={`bold`}>
                                            TRANSFER
                                        </Typography>
                                    </th>
                                    <th align="center">
                                        <Typography align="center" fontSize={`0.75rem`} fontWeight={`bold`}>
                                            BEFORE
                                        </Typography>
                                    </th>
                                    <th align="center">
                                        <Typography align="center" fontSize={`0.75rem`} fontWeight={`bold`}>
                                            AFTER
                                        </Typography>
                                    </th>
                                    <th colSpan={4}></th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    transactions.length > 0 ? transactions.sort((a: payinTransactionsType, b: payinTransactionsType) => {
                                        const dateA = new Date(a.createdAt).getTime();
                                        const dateB = new Date(b.createdAt).getTime();
                                        return dateB - dateA;
                                    }).map((transaction: payinTransactionsType, index: number) => {
                                        return (
                                            <tr key={index} style={
                                                {
                                                    backgroundColor: transaction.status === 1 ? "rgba(0, 190, 0, .2)" : (
                                                        transaction.status === 0 ? "rgba(190, 190, 0, .2)" : "rgba(255, 0, 0, .2)"
                                                    ),
                                                    transition: 'all .3s'
                                                }
                                            }>
                                                <td>
                                                    <Tooltip title={`Remark: ${transaction.remark}`}>
                                                        <Typography align="center" fontSize={`0.75rem`}>
                                                            <b>
                                                                {
                                                                    transaction.ref_code
                                                                }
                                                            </b>
                                                            <Divider />
                                                            {
                                                                transaction.customer_ref_code
                                                            }
                                                        </Typography>
                                                    </Tooltip>
                                                </td>
                                                <td>
                                                    <Typography align="center" fontSize={`0.95rem`}>
                                                        ฿{
                                                            parseFloat(String(`${transaction.full_amount}`)).toLocaleString('en-US', {
                                                                minimumFractionDigits: 2,
                                                                maximumFractionDigits: 2
                                                            })
                                                        }
                                                    </Typography>
                                                </td>
                                                <td>
                                                    <Typography align="center" fontSize={`0.95rem`}>
                                                        ฿{
                                                            parseFloat(String(`${transaction.transfer_amount}`)).toLocaleString('en-US', {
                                                                minimumFractionDigits: 2,
                                                                maximumFractionDigits: 2
                                                            })
                                                        }
                                                    </Typography>
                                                </td>
                                                <td>
                                                    <Typography align="center" fontSize={`0.95rem`}>
                                                        ฿{
                                                            parseFloat(String(`${transaction.agent_balance_before}`)).toLocaleString('en-US', {
                                                                minimumFractionDigits: 2,
                                                                maximumFractionDigits: 2
                                                            })
                                                        }
                                                    </Typography>
                                                </td>
                                                <td>
                                                    <Typography align="center" fontSize={`0.95rem`}>
                                                        ฿{
                                                            parseFloat(String(`${transaction.agent_balance_after}`)).toLocaleString('en-US', {
                                                                minimumFractionDigits: 2,
                                                                maximumFractionDigits: 2
                                                            })
                                                        }
                                                    </Typography>
                                                </td>
                                                <td>
                                                    <Typography align="center" fontSize={`0.95rem`}>
                                                        {
                                                            transaction.status === 1 ? "SUCCESS" : (
                                                                transaction.status === 0 ? "PENDING" : "FAIL"
                                                            )
                                                        }
                                                    </Typography>
                                                </td>
                                                <td>
                                                    <Typography align="center" fontSize={`0.95rem`}>
                                                        {
                                                            `${String(new Date(String(transaction.updatedAt)).getDate()).padStart(2, '0')}/${String(new Date(String(transaction.updatedAt)).getMonth() + 1).padStart(2, '0')}/${String(new Date(String(transaction.updatedAt)).getFullYear())}`
                                                        }&nbsp;{
                                                            `${String(new Date(String(transaction.updatedAt)).getHours()).padStart(2, '0')}:${String(new Date(String(transaction.updatedAt)).getMinutes()).padStart(2, '0')}:${String(new Date(String(transaction.updatedAt)).getSeconds()).padStart(2, '0')}`
                                                        }
                                                    </Typography>
                                                </td>
                                                <td>
                                                    <Typography align="center" fontSize={`0.95rem`}>
                                                        {
                                                            `${String(new Date(String(transaction.createdAt)).getDate()).padStart(2, '0')}/${String(new Date(String(transaction.createdAt)).getMonth() + 1).padStart(2, '0')}/${String(new Date(String(transaction.createdAt)).getFullYear())}`
                                                        }&nbsp;{
                                                            `${String(new Date(String(transaction.createdAt)).getHours()).padStart(2, '0')}:${String(new Date(String(transaction.createdAt)).getMinutes()).padStart(2, '0')}:${String(new Date(String(transaction.createdAt)).getSeconds()).padStart(2, '0')}`
                                                        }
                                                    </Typography>
                                                </td>
                                            </tr>
                                        )
                                    }) :
                                        <tr>
                                            <td colSpan={12}>
                                                <Typography align="center" fontSize={`0.95rem`}>
                                                    NOT FOUND TRANSACTIONS
                                                </Typography>
                                            </td>
                                        </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="col-12 mt-3">
                    <div className="card p-2">
                        <div className="row g-2">
                            <div className="col-sm-12 col-xl-6" style={{
                                display: 'flex',
                                alignContent: `center`,
                                alignItems: `center`
                            }}>
                                <CustomPagination
                                    count={Math.ceil((countTransactions === null ? 0 : countTransactions) / limit)}
                                    color="primary"
                                    sx={{ color: 'white'}}
                                    onChange={handleChangePage}
                                    page={page}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </>
        </>
    )
}

export default PayinTransactions;